/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import "./App.css";
import useExternalScripts from "./hooks/useExternalScripts";

import MainWrapper from "./components/MainWrapper";
import DashboardWrapper from "./components/DashboardWrapper";
import Page404 from "./components/pages/ErrorsPage/404";
import DashboardMaintenance from "./components/pages/DashboardPage/Maintenance";

function App() {
  useExternalScripts("shortcodes.js");
  useExternalScripts("main.js");

  const isDashboardAvailable = process.env.REACT_APP_DASHBOARD_AVAILABLE === "true";

  return (
    <Router>
      <Routes>
        <Route path="/*" Component={MainWrapper} />
        <Route path="/dashboard/*" Component={isDashboardAvailable?DashboardWrapper:DashboardMaintenance} />*
        <Route path="/not-found" Component={Page404} />
      </Routes>
    </Router>
  );
}

export default App;
